'use client'


import Heading from '@/components/Heading/Heading'
import RoleListView from './RoleListView'

export default function Home() {
  return (
    <div className="flex w-full bg-white gap-[32px]">
      <div className="flex-grow">
        <Heading
          title={'Roles'}
          description={'Manage user roles.'}
          parent={{
            title: 'Users',
            url: '/users',
          }}
        >
        </Heading>
        <RoleListView />
      </div>
    </div>
  )
}
